import LiveChatLogo from '../media/LiveChatLogo.svg';
import RequestCallLogo from '../media/RequestCallLogo.svg';

export const getFloatingHelpStyles = () => ({
  floatingHelp: {
    position: 'fixed',
    right: 32,
    zIndex: 2,
    boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.25)',

    '& .floating-help-contact-us-button': {
      minHeight: 63,
      width: 233,
      background: '#004578',
      textAlign: 'left',
      fontWeight: 'normal',
      borderRadius: 0,
      display: 'flex',

      '&:hover': {
        background: '#004578',
      },

      '& .iconba': {
        paddingRight: 12,
      },
    },

    '& .floating-contact-us-text': {
      wordBreak: 'break-word',
      whiteSpace: 'normal',
      alignSelf: 'center',
    },

    '& .floating-contact-us-icon': {
      alignSelf: 'center',
    },

    '& .floating-help-group': {
      position: 'relative',
      background: '#004578',

      '& .floating-chat-button, .floating-call-button': {
        minHeight: 63,
        width: 233,
        textAlign: 'left',
        fontWeight: 'normal',
        borderRadius: 0,

        '& > span': {
          verticalAlign: 'middle',
        },

        '& .glyphicon': {
          backgroundRepeat: 'no-repeat',
          width: 24,
          height: 24,
          marginRight: 12,
        },

        '& .floating-chat-glyph': {
          backgroundImage: `url("${LiveChatLogo}")`,
        },

        '& .floating-call-glyph': {
          backgroundImage: `url("${RequestCallLogo}")`,
        },

        '& .floating-chat-text, .floating-call-text': {
          display: 'inline-block',
          width: 140,
          wordBreak: 'break-word',
          whiteSpace: 'normal',
          textDecoration: 'underline',
        },
      },

      '& .floating-group': {
        background: '#0078d4',
      },

      '& hr': {
        marginTop: 0,
        marginBottom: 0,
        width: 190,
        borderTop: '1px solid rgba(255, 255, 255, 0.3)',
      },
    },
  },
  mobileView: {
    '@media only screen and (max-width: 600px)': {
      right: 5,
      '& .floating-help-contact-us-button': {
        width: 170,
      },
    },
  },
});
